import React from "react";
import moment from "moment";
import { connect } from "react-redux";

import Button from "@material-ui/core/Button";

import QuantitySelector from "../../QuantitySelector";
import Currency from "../../Currency";
import GroupTitle from "../../GroupTitle";
import SpotlioButton from "../../Button";
import SpotlioIcon from "../../Icon";
import Modal from "../../Modal";
import QuantityPicker from "../../quantityPicker";

import getDateFormat from "../../../utils/DateFormatRetriever";
import { getSystemSettings } from "../../../utils/SettingsRetriever";
import IntlMessage from "../../../LocaleEngine";
import TaxesAndFeesText from "../../../utils/taxesAndFees";

class Option extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      amount: props.minQuantity || 1,
      loading: false,
      modal: false,
      amountOfDays: 1 
    };
  }

  changePrice = (index, value) => {
    this.setState({ amount: value });
  };

  changeDays = (value) => {
    this.setState({ amountOfDays: value })
  }

  addToCart = (element, amount) => {
    this.setState({ loading: true, amount: 1, amountOfDays: 1 });
    this.props.addToCart(element, amount, () =>
      this.setState({ loading: false }), this.state.amountOfDays
    );
  };

  getCurrency = (displayType) => {
    const { amount, amountOfDays } = this.state;
    const { element } = this.props;

    let currency = null;
    switch (displayType) {
      case 1:
        currency = (
          <React.Fragment>
            <span className="originalPrice">
              <Currency
                float={true}
                displayType={displayType}
                strikeThrough={true}
                onlyOriginal={true}
                value={element.OriginalPrice * amount * amountOfDays}
              />
            </span>
          </React.Fragment>
        );
        break;
      case 2:
        currency = (
          <React.Fragment>
            <span
              style={
                element.OriginalPrice - element.Price === 0
                  ? { visibility: "hidden" }
                  : {}
              }
              className="originalPrice"
            >
              <Currency
                displayType={displayType}
                float={true}
                strikeThrough={true}
                onlyOriginal={true}
                value={element.OriginalPrice * amount * amountOfDays}
              />
            </span>
            <Currency float={true} value={element.Price * amount * amountOfDays} />
          </React.Fragment>
        );
        break;
      case 3:
        break;
      default:
        break;
    }
    return currency;
  };

  getFloat = (configuration) => {
    let float = true;
    if (configuration && configuration.config && configuration.config.pricing) {
      float = configuration.config.pricing.decimal;
    }
    return float;
  };

  checkIfAddOrDelete = (value) => {
    if (!this.props.element.Quantity || value > this.props.element.Quantity) {
      this.props.addQuantity(this.props.element, value);
    } else {
      this.props.reduceQuantity(this.props.element, value);
    }
  };

  getQuantity() {
    let foundInCart = this.props.packageCart.find((prod) => {
      return (
        prod.ProductId === this.props.element.ProductId &&
        prod.arrivalDate === this.props.dateOfActivity
      );
    });
    if (foundInCart) return foundInCart.Quantity;
    return 0;
  }

  getCTAAction = () => {
    const { props, state, addToCart } = this;
    const { element, maxQuantity } = props;
    const { amount, loading } = state;

    if (props.quantityPicker) {
      return (
        <QuantityPicker
          minQuantity={props.minQuantity || 0}
          maxQuantity={maxQuantity}
          quantity={this.getQuantity()}
          setQuantity={this.checkIfAddOrDelete}
        />
      );
    }

    if (props.isPackage) {
      return (
        <Button onClick={() => addToCart(element, amount)} className="book">
          <IntlMessage id="package.cell.option.add" />
        </Button>
      );
    }
    return (
      <SpotlioButton
        loading={loading}
        callBack={() => addToCart(element, amount)}
        className="book"
      >
        <IntlMessage
          id={
            props.config &&
            props.config.label_customization &&
            props.config.label_customization.book_now_label
              ? props.config.label_customization.book_now_label
              : "activities.cell.option.book_now"
          }
        />
      </SpotlioButton>
    );
  };

  getShortNameConfig = () => {
    if (
      getSystemSettings().app &&
      getSystemSettings().app.packages &&
      getSystemSettings().app.packages.shortName
    )
      return true;
    return false;
  };

  getMaxQuantity = () => {
    const maxQuantity = this.props.maxQuantity;
    const elementQuantity = this.props.element.Quantity;
    
    // Get the minimum quantity that is not zero
    const minQuantity = Math.min(maxQuantity || 20, elementQuantity || 1);
    
    // Ensure the quantity is not zero
    if (minQuantity === 0) {
      return Math.max(maxQuantity, elementQuantity);
    }
    
    return minQuantity;
  }

  render() {
    const { props, state, getFloat } = this;
    const { index, element, date, configuration } = props;
    const { amount, loading, modal, amountOfDays } = state;
    const systemSettings = getSystemSettings();
    const { new_rental_system } = systemSettings;
    return (
      <React.Fragment>
        <div className="product" key={index}>
          <div className="productname">
            {configuration &&
            configuration.config &&
            configuration.config.products &&
            configuration.config.products.more_info ? (
              <SpotlioIcon
                icon={"feather-info"}
                onClick={() => this.setState({ modal: true })}
                size={20}
              />
            ) : null}
            <GroupTitle
              smallTitle={true}
              element={element}
              isShort={this.getShortNameConfig()}
            />
          </div>
          {props.dateOfActivity ? (
            <div className="date">
              {moment.utc(props.dateOfActivity).format(getDateFormat())}
            </div>
          ) : (
            <div className="date">
              {moment
                .utc(this.props.form.activities.startDate)
                .format(getDateFormat())}
            </div>
          )}
          {!props.quantityPicker ? (
            <div className="amount">
              <QuantitySelector
                showSymbol={"x"}
                min={props.minQuantity}
                max={this.getMaxQuantity()}
                default={amount}
                name="items"
                whenChange={(index, value) => this.changePrice(index, value)}
              />
            </div>
          ) : null}
          {
            new_rental_system && new_rental_system.enabled && new_rental_system.suppliers.find(supplier => supplier === props.element.SupplierId) ?
            <div className="amount">
              <QuantitySelector
                showSymbol={"x"}
                min={1}
                max={14}
                default={amountOfDays}
                name="items"
                whenChange={(index, value) => this.changeDays(value)}
              />
            </div>
            : null
          }
          <div className="price">
            {props.displayType !== undefined ? (
              this.getCurrency(props.displayType)
            ) : (
              <React.Fragment>
                <Currency
                  float={getFloat(configuration)}
                  value={element.Price * amount * amountOfDays}
                />
                {element.Savings && (
                  <div className="discount">{element.Savings.label}</div>
                )}
              </React.Fragment>
            )}
            {TaxesAndFeesText(element)}
          </div>
          {this.getCTAAction()}
        </div>
        <div className="mobileProduct">
          <div className="productname">
            <GroupTitle
              smallTitle={true}
              element={element}
              isShort={this.getShortNameConfig()}
            />
            {props.dateOfActivity ? (
              <div className="date">
                {moment.utc(props.dateOfActivity).format(getDateFormat())}
              </div>
            ) : (
              <div className="date">
                {moment
                  .utc(this.props.form.activities.startDate)
                  .format(getDateFormat())}
              </div>
            )}
          </div>
          <div className="productcontent">
            <div className="pricing">
              <Currency float={true} value={element.Price * amount * amountOfDays} />
            </div>
            <div className={"amount" + (!date ? "-nodate" : "")}>
              <QuantitySelector
                showSymbol={"x"}
                min={props.minQuantity}
                max={this.getMaxQuantity()}
                default={amount}
                name="items"
                whenChange={(index, value) => this.changePrice(index, value)}
                native={window.innerWidth <= 991}
              />
            </div>
          </div>
          {props.isPackage ? (
            <Button
              onClick={() => this.addToCart(element, amount)}
              className="book"
            >
              <IntlMessage id="activities.cell.option.book_now" />
            </Button>
          ) : (
            <SpotlioButton
              loading={loading}
              callBack={() => this.addToCart(element, amount)}
              className="book"
            >
              <IntlMessage id="activities.cell.option.book_now" />
            </SpotlioButton>
          )}
        </div>
        <Modal
          open={modal}
          title={element.ProductName}
          className="infoItem"
          closeFn={() => this.setState({ modal: false })}
          footerContent={
            <Button
              onClick={() => this.setState({ modal: false })}
              className="secondary"
            >
              <IntlMessage id="profile.itinerary.modal.close" />
            </Button>
          }
        >
          <div className="body">
            <div>{element.ProductDescription}</div>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return { form: state.form.form };
}

export default connect(mapStateToProps)(Option);
